import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export function formatSince(date: string, time: string): string {
    return `${date}T${time}Z`;
}

export function windowEndLabel(date: string, time: string): string {
    return dayjs(`${date}T${time}`).add(6, 'hour').format('HH:00');
}

// "-04:00" → -240 ; "+05:30" → 330 ; formato inválido/IANA/vacío → 0.
export function offsetToMinutes(offset: string): number {
    const m = /^([+-])(\d{2}):(\d{2})$/.exec(offset);
    if (!m) {
        return 0;
    }
    const sign = m[1] === '-' ? -1 : 1;
    return sign * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10));
}

// Convierte un instante absoluto al wall-clock del sitio (offset del lock, ej "-04:00"),
// truncado a la hora.
export function instantToWallClock(instant: dayjs.Dayjs, offset: string): { date: string; time: string } {
    const local = instant.utcOffset(offsetToMinutes(offset));
    return { date: local.format('YYYY-MM-DD'), time: local.format('HH:00:00') };
}

// "Ahora" en el wall-clock del sitio (offset del lock) para que el backend, que reinterpreta el
// "Z" en la TZ del lock, reciba la hora local correcta. Sin offset → wall-clock del device (fallback).
export function nowSince(offset?: string): { date: string; time: string } {
    if (!offset) {
        const now = dayjs();
        return { date: now.format('YYYY-MM-DD'), time: now.format('HH:00:00') };
    }
    return instantToWallClock(dayjs(), offset);
}
